<oui-layout
  [logoUrl]="logoUrl"
  [menu]="menu()"
  [menuType]="'internal'">
  <oui-content-layout>
    <ng-template #filtrerPortalContent>
      <app-filtrer-investisseurs></app-filtrer-investisseurs>
    </ng-template>
    <ng-template #qpiViewerPortalContent>
      <app-qpi-viewer-page></app-qpi-viewer-page>
    </ng-template>
    <ng-template #signatairePortalContent>
      <app-signataire-details></app-signataire-details>
    </ng-template>
    <ng-template #filePortalContent>
      <app-file-viewer></app-file-viewer>
    </ng-template>
    <div class="app-container">
      @if (!authService.isInitLogin()) {
        <oui-side-nav-menu
          [menuItems]="menu()"
          [logoSrc]="logoUrl"
          [userName]="authService.getUserInfo().fullName"
          [avatarSrc]="authService.consultantProfilePicture()"
          [avatarMenuItems]="userMenu"
          [appVersion]="currentVersion">
        </oui-side-nav-menu>
        <div class="main-container">
          <div class="content-container">
            <router-outlet></router-outlet>
          </div>
        </div>
      }
    </div>
    @if (loadingService.isLoading$ | async) {
      <div class="loader">
        <oui-loading class="center"></oui-loading>
      </div>
    }
  </oui-content-layout>
</oui-layout>
